import { Phone } from "lucide-react";

const FloatingCallButton = () => {
    return (
        <a
            href="tel:+33649501843"
            data-testid="floating-call-btn"
            aria-label="Appeler directement Atelier Beauchamp au 06 49 50 18 43"
            className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group md:hidden"
        >
            {/* Pulsing ring */}
            <span className="absolute inset-0 rounded-full bg-[#E63946] opacity-70 animate-ping" aria-hidden="true"></span>
            <span className="absolute inset-0 rounded-full bg-[#E63946]/40 animate-pulse" aria-hidden="true" style={{ animationDelay: "0.3s" }}></span>

            {/* Main button */}
            <span className="relative flex items-center gap-2 sm:gap-3 bg-[#E63946] hover:bg-[#D62828] text-white px-4 sm:px-5 py-3 sm:py-4 rounded-full shadow-xl shadow-[#E63946]/40 transition-colors duration-200 border-2 border-white">
                <Phone className="h-5 w-5 animate-pulse" strokeWidth={2.6} />
                <span className="font-display font-bold text-sm sm:text-base uppercase tracking-tight whitespace-nowrap">
                    Appeler
                </span>
            </span>
        </a>
    );
};

export default FloatingCallButton;
